<div class="neural-section">
  <div class="neural-inner">
    <div class="neural-header">
      <div class="neural-tag">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path></svg>
        Processamento de extratos de mais de 160 Bancos
      </div>
      <h2 class="neural-title">O Mister no <span>centro</span> de tudo</h2>
      <p class="neural-subtitle">O Mister Contador importa extratos, notas fiscais e comprovantes para organizar e estruturar o seu departamento contábil.</p>
    </div>

    <div class="neural-canvas-wrap">
      <canvas #canvas></canvas>
    </div>
  </div>
</div>
